import { List } from './List';

export type DataList = {
    list: ListConfig;
    columns: Array<DataListColumn>;
    rows: Array<RowData>;
};

export type ListConfig = {
    data_list_name: string;
    data_list_type: string;
    id: string;
    columns: Array<DataListColumn> | undefined;
};

export class ListData {
    list: ListConfig;

    constructor(listConfig: DataList) {
        this.list = listConfig.list;
    }
}

export type DataListCell = {
    column_ordinal: string;
    id: string;
    is_raw_json: string;
    row_id: string;
    row_ordinal: string | number;
    value: DataListCellValue;
};

//Cell.value can be a lot of things...
export type DataListCellValue =
    | string
    | List
    | null
    | Record<string, unknown>
    | Array<SerializedRow | Record<string, unknown>>
    | Array<RowData | RowWithNormalizedData>;

export type RowData = Array<DataListCell>;

export type ListMetadata = {
    data_list_name: string;
    data_list_type: string;
    id: string;
    columns: Array<DataListColumn>;
};

export type DataListColumn = {
    data_list_id: string;
    id: string;
    is_identity: boolean;
    name: string;
    ordinal: string;
    ordinal_as_alpha: string;
    type: string; // Some known values: 'TEXT' | 'IMAGE'
    width: string;
    width_in_pixels: number;
};

export interface NormalizedRowData {
    [key: string]: DataListCell | SerializedRow;
}

//a normalized row has column names as keys with the value being the cell value for each column
export type SerializedRow = {
    [key: string]: string | DataListCellValue;
};

export type RowWithNormalizedData = Array<{ [key: number]: NormalizedRowData }>;

export type RowConfig = {
    id: string;
    ordinal: string;
};
